import { useEffect, useState } from "react";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import OtpInputs from "components/OtpInputs";
import Timer from "components/Timer";
import {
  useChangePhoneMutation,
  useChangePhoneOtpMutation,
} from "redux/RTQ/IlenkradApi";
import { ToastDanger } from "utils/toast/Toast";
import { useNavigate } from "react-router";

const OtpModal = ({ open, newMobile, onClose, setPhoneNumberChanged }: any) => {
  const [sendCode, setSendCode] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [smsCode, setSmsCode] = useState<string[]>(["", "", "", "", ""]);
  // api verify
  const [mutate, { data, isSuccess, isError, isLoading }] =
    useChangePhoneMutation();

  const [
    mutateOtp,
    {
      data: dataOtp,
      isLoading: isLoadingOtp,
      isError: isErrorOtp,
      error: otpError,
    },
  ] = useChangePhoneOtpMutation();
  const submitSmsCode = () => {
    if (requiredVerifyPassword(smsCode[0]).error) {
      setError(true);
      return;
    }
    const array = [...smsCode];
    const otp: string = array.reverse().join("");
    const otp_id: any = dataOtp;
    const obj: any = { otp: Number(otp), otp_id: otp_id?.otp_id };
    mutate(obj);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (isErrorOtp || isError) {
      const erOtp = otpError as any;
      ToastDanger(erOtp?.data?.message);
      localStorage.removeItem("otpTime");
      if (erOtp?.data?.code === "invalid_request") {
        onClose();
        setTimeout(() => {
          navigate("/home");
        }, 600);
        setTimeout(() => {
          navigate("/profile");
        }, 1000);
        localStorage.removeItem("otpTime");
      }
    }
  }, [isError, isErrorOtp, otpError]);

  const SendOtp = () =>
    mutateOtp({
      new_phone_number: newMobile,
    });

  // method

  const requiredVerifyPassword = (value: any) => {
    if (value === 0 || value === "" || value === undefined || value === null) {
      return { error: true };
    } else {
      return { error: false };
    }
  };

  useEffect(() => {
    if (sendCode) {
      SendOtp();
      setSendCode(false);
    }
  }, [sendCode]);

  useEffect(() => {
    const dataSuccess: any = data;
    if (isSuccess && dataSuccess?.success === true) {
      onClose();
      setPhoneNumberChanged(true);
      localStorage.removeItem("otpTime");
    }
  }, [isSuccess]);

  return (
    <>
      <OverlayModalCommon onClose={onClose} open={open}>
        <div className={"contentModalSettingsMap"}>
          <div className="loginContainer">
            <div className="formContainerLogin">
              <div className="verifyText">
                کد ارسال شده به شماره موبایل جدید خود را اینجا وارد نمایید
              </div>
              <div className="timerTextMobile">{newMobile}</div>

              <OtpInputs error={error} setSmsCode={setSmsCode} />

              <Timer setSendCode={setSendCode} />
              <div className="rowBtnSettingsMap">
                <div
                  onClick={
                    isLoadingOtp || isLoading ? () => {} : () => submitSmsCode()
                  }
                  className="BtnSettingsMapSubmit"
                >
                  تایید
                </div>
                <div
                  onClick={() => {
                    onClose();
                    localStorage.removeItem("otpTime");
                  }}
                  className="BtnSettingsMapCancel pointer"
                >
                  انصراف
                </div>
              </div>
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default OtpModal;
